import React, {useEffect, useState} from "react";
import {DatePicker, Form, Modal, Select} from "antd";
import {assetSearch, categoryList} from "../../../asset/asset-category/action/asset-category.action";
import Locale from "../../../../core/locale/locale";
import TextArea from "antd/es/input/TextArea";
import {IAssetAllocateModalProps} from "../../types/asset.types";
import AssetSelect from "../../../common/asset-select/asset-select";

const AssetAllocateModal = (props: IAssetAllocateModalProps) => {
    const [assetCategoryData, setAssetCategoryData] = useState([]);

    useEffect(() => {
        fetchAssetCategory();
    }, [])

    useEffect(() => {
        if (props.selectedAssetAllocatedRecord) {
            props.assetAllocateForm.setFieldsValue({
                categoryId: props.selectedAssetAllocatedRecord.assetCategory?.id
            });
            fetchAssets(props.selectedAssetAllocatedRecord.assetCategory?.id);
        }
    }, [props.selectedAssetAllocatedRecord]);

    async function fetchAssetCategory() {
        try {
            const assetCategoryResponse = await categoryList();
            setAssetCategoryData(assetCategoryResponse)
        } catch (error) {
            console.log("Getting error while fetching asset categories", error)
        }
    }

    async function fetchAssets(categoryId?: string) {
        if (!categoryId) return;
        try {
            const payload = {categoryId, status: "IN_STOCK"};
            await assetSearch(undefined, undefined, payload);
        } catch (e) {
            console.log("Error while fetching assets", e);
        }
    }

    return (
        <Modal
            className={'hrms-app asset-allocate-modal'}
            title={"Allocate Asset"}
            open={props.assetAllocateModal}
            onCancel={props.handleAssetAllocateModalClose}
            okText={"Allocate"}
            onOk={async () => {
                try {
                    const values = await props.assetAllocateForm.validateFields();
                    await props.handleAssetAllocateSubmit(values);
                } catch (e) {
                    console.log(e)
                }
            }}
        >
            <Form form={props.assetAllocateForm}>
                <Form.Item
                    label="Select Category"
                    name={"categoryId"}
                    rules={[{required: true, message: 'Select Category'}]}
                >
                    <Select
                        placeholder="Select Category" disabled
                    >
                        {assetCategoryData.map((cat: any) => (
                            <Select.Option key={cat.id} value={cat.id}>
                                {cat.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    label={"Select Asset"}
                    name={'assetId'}
                    rules={[{required: true, message: 'Select Asset'}]}
                >
                    <AssetSelect
                        includeAllSelectOption={false}
                        placeholder={"Select Asset"}
                        categoryId={props.selectedAssetAllocatedRecord?.assetCategory?.id}
                    />
                </Form.Item>

                <Form.Item label={"Expected Return Date"} name={'expectedReturnDate'}>
                    <DatePicker format={Locale.displayDate}/>
                </Form.Item>

                <Form.Item label={"Remarks"} name={'adminRemarks'}>
                    <TextArea placeholder={"Enter Remarks"}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default AssetAllocateModal;
